<script setup>
import { RouterView, useRouter } from 'vue-router'
import { computed } from 'vue'

const router = useRouter()

// 收集所有 keepAlive: true 的路由对应的组件名
const cachedViews = computed(() => {
  return router.getRoutes()
    .filter(route => route.meta?.keepAlive)
    .map(route => route.name)
    .filter(Boolean)
})
</script>

<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :include="cachedViews">
      <component :is="Component" :key="route.name" />
    </keep-alive>
  </router-view>
</template>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
</style>
